<template>

  <div :id="_uid" class="ui mini modal change-email-modal">
    <div class="ui header">
      Alterar E-mail
    </div>
    <div class="content">
      <div class="ui form">
        <div class="fields">
          <div class="sixteen wide field">
            <label class="form-label">Senha atual <span class="red text">*</span></label>
            <input type="password" v-model="currentPassword">
          </div>
        </div>
        <div class="fields">
          <div class="sixteen wide field">
            <label class="form-label">Novo e-mail <span class="red text">*</span></label>
            <input v-model="newEmail">
          </div>
        </div>
        <div class="fields">
          <div class="sixteen wide field">
            <label class="form-label">Confirme o novo e-mail <span class="red text">*</span></label>
            <input v-model="confirmNewEmail">
          </div>
        </div>
      </div>
    </div>
    <div class="actions">
      <button class="ui cancel basic button">
        <i class="times icon"></i>
        Cancelar
      </button>
      <button class="ui blue button" :class="{ disabled: !canConfirm, loading: updating }" @click="onConfirm()">
        <i class="check icon"></i>
        Confirmar
      </button>
    </div>
  </div>

</template>

<script>

  import AuthService from "@/services/auth-service"

  export default { 

    data() {
      return {
        updating: false,
        currentPassword: "",
        newEmail: "",
        confirmNewEmail: "",
      }
    },

    beforeDestroy() {
      $(".change-email-modal").remove()
    },

    computed: {

      canConfirm() {

        let canConfirm = true

        if (!this.currentPassword || !this.newEmail || !this.confirmNewEmail)
          canConfirm = false

        return canConfirm
      },
    },
    
    methods: {

      show() {

        this.currentPassword = ""
        this.newEmail = ""
        this.confirmNewEmail = ""

        $(`#${this._uid}`).modal("show")
      },

      hide() {
        $(`#${this._uid}`).modal("hide")
      },

      async onConfirm() {

        if (this.newEmail != this.confirmNewEmail) {
          this.$msg.info("E-mail não confirmado corretamente")
          return
        }

        this.updating = true

        try {

          await new AuthService().updateEmail(this.currentPassword, this.newEmail)

          this.hide()

          this.$msg.success("E-mail alterado com sucesso")
          
        } catch (error) {

          if (error.code && error.code == "auth/wrong-password") {
            this.$msg.warn("Senha atual inválida")
          } else {
            this.$errorHandler(error)
          }          

        } finally {
          
          this.updating = false
        }
      },
    },
  }

</script>

